import { Language } from '../types/common'

export default (): Language => {
  return document.querySelector('html[lang="en"]') ? 'en' : 'cs'
}
